export const getImageUrl = (imageUrl) => {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const height = 500 * dpr;
    return `https:${imageUrl}?h=${height}&q=85`;
};

// Function that sets the longest side to 500px while maintaining aspect ratio
export const getImageUrlWithLongestSide = (imageUrl) => {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const maxSize = 500 * dpr;

    // Use height parameter to set height to maxSize for both orientations
    // For landscape: height will be maxSize, width auto
    // For portrait: height will be maxSize, width auto
    // Add WebP format for better performance
    return `https:${imageUrl}?h=${maxSize}&q=75`;
};

